module.exports = __webpack_public_path__ + "img/tours_7.b94a2585.jpg";